angular.module("khUtils").factory("KhutilsCropListFactory", ["$resource", function ($resource) {
    return $resource('/api/v1.0/fieldplotcrop/croplist/');
}]);